module.exports = __webpack_public_path__ + "assets/img/5-1.f47c712c.png";